import './minifield-logo.css';
const MinifieldLogo = () => <h1 className="mf-logo">Minifield</h1>;
export default MinifieldLogo;